import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    // default screen for a new board
    setFlowTo(normalizePath(props.viewPath, `../../ArchiveModal/Content`))
  }
}
